import type { Template } from "@/types";

export const PO_04_H4_V0: Template[] = [
    {
        id: "hs-04-h4v0-01",
        name: "PO 01 - H4V0",
        albumType: "Hr",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 173, y: 111, width: 473, height: 299, rotation: 0, imageRotation: 0 },
            { id: "2", x: 173, y: 418, width: 473, height: 299, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 111, width: 472, height: 299, rotation: 0, imageRotation: 0 },
            { id: "4", x: 654, y: 418, width: 472, height: 299, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-02",
        name: "PO 02 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 83, y: 102, width: 484, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 83, y: 417, width: 484, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 731, y: 102, width: 484, height: 307, rotation: 0, imageRotation: 0 },
            { id: "4", x: 731, y: 417, width: 484, height: 307, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-03",
        name: "PO 03 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 301, width: 319, height: 226, rotation: 0, imageRotation: 0 },
            { id: "2", x: 327, y: 301, width: 319, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 301, width: 319, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 981, y: 301, width: 318, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-04",
        name: "PO 04 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_04.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 0, y: 508, width: 319, height: 226, rotation: 0, imageRotation: 0 },
            { id: "2", x: 327, y: 508, width: 319, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 654, y: 508, width: 318, height: 226, rotation: 0, imageRotation: 0 },
            { id: "4", x: 980, y: 508, width: 318, height: 226, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-05",
        name: "PO 05 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_05.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 55, y: 67, width: 541, height: 343, rotation: 0, imageRotation: 0 },
            { id: "2", x: 55, y: 418, width: 541, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 703, y: 67, width: 541, height: 343, rotation: 0, imageRotation: 0 },
            { id: "4", x: 703, y: 418, width: 541, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-06",
        name: "PO 06 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_06.png",
        size: [1298, 827],
        style: {},
        slots: [           
            { id: "1", x: 62, y: 71, width: 346, height: 224, rotation: 0, imageRotation: 0 },
            { id: "2", x: 62, y: 303, width: 346, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 62, y: 534, width: 346, height: 223, rotation: 0, imageRotation: 0 },
            { id: "4", x: 710, y: 246, width: 527, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-07",
        name: "PO 07 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 65, y: 189, width: 518, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 710, y: 189, width: 518, height: 298, rotation: 0, imageRotation: 0 },
            { id: "3", x: 710, y: 495, width: 255, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 973, y: 495, width: 255, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-08",
        name: "PO 08 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_08.png",
        size: [1298, 827],
        style: {},
        slots: [        
            { id: "1", x: 72, y: 90, width: 326, height: 212, rotation: 0, imageRotation: 0 },
            { id: "2", x: 72, y: 310, width: 326, height: 211, rotation: 0, imageRotation: 0 },
            { id: "3", x: 72, y: 529, width: 326, height: 211, rotation: 0, imageRotation: 0 },
            { id: "4", x: 406, y: 90, width: 820, height: 650, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-09",
        name: "PO 09 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_09.png",
        size: [1298, 827],
        style: {},
        slots: [          
            { id: "1", x: 125, y: 153, width: 256, height: 169, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 330, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "3", x: 125, y: 506, width: 256, height: 168, rotation: 0, imageRotation: 0 },
            { id: "4", x: 389, y: 153, width: 783, height: 521, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-04-h4v0-10",
        name: "PO 10 - H4V0",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-04-h4_v0_10.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 33, y: 32, width: 596, height: 379, rotation: 0, imageRotation: 0 },
            { id: "2", x: 33, y: 419, width: 596, height: 378, rotation: 0, imageRotation: 0 },
            { id: "3", x: 670, y: 32, width: 596, height: 379, rotation: 0, imageRotation: 0 },
            { id: "4", x: 670, y: 419, width: 596, height: 378, rotation: 0, imageRotation: 0 }
        ],
    }
];